<button class="cart-btn primary-bg-color primary-text-color primary-border-color" [title]="'component.header.cart_button.button_title' | translate">
  <fa-icon [size]="'lg'" [fixedWidth]="true" [icon]="faFtsCart"></fa-icon>
  <span *ngIf="order?.itemsCount" class="item-count fw-600">{{order?.itemsCount}}</span>
</button>
